import {ApiResponse} from '../../data/types/interface/api';
import {Garanty} from '../../data/types/interface/Contrats/contratRattacher';
import api, {postFormData} from '../technique/api';

export interface IPostTarifParams {
  policyNumber: string;
  startDate: string;
  duration: string;
}

export interface IPostTarifAutoParams {
  policyNumber: string;
  startDate: string;
}
export interface IPostTarifRensponse {
  prime: number;
}

export interface IPostTarifAutoResponse {
  primeTTC: number;
  garanties: Garanty[];
}

export interface IPostSaveParams {
  numeroPolice: string;
  primeTTC: string;
  dateEffet: string;
  duration: number;
  operationType: string;
  simulationId: string;
  utilisateur: string;
}

export interface ISaveContratAuto extends IPostSaveParams {
  acceptTerm: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  vehiculeImageAvant: any;
}
export interface IPostSaveResponse {
  isError: boolean;
  message: string;
  idSimulation: string;
}
export interface IDeleteContratRattache {
  id: string;
}
export const ContratBDL = () => ({
  getDetailContrat: async (numeroPolice: string) =>
    await api.get(
      `common/contrat/numero-police/?numeroPolice=${numeroPolice}&date=`,
    ),
  deleteRcvp: async (simulationId: string) =>
    await api.remove(`assurance-rcvp/contrat/rcvp/?id=${simulationId}`),
  deleteScolaire: async (simulationId: string) =>
    await api.remove(`scolaire/contrat/scolaire/?id=${simulationId}`),

  // GET montant contrat rattache
  getMontant: async (
    data: IPostTarifParams,
  ): Promise<ApiResponse<IPostTarifRensponse>> => {
    return await api.get(
      `common/pricing?policyNumber=${data.policyNumber}&startDate=${data.startDate}&duration=${data.duration}`,
    );
  },

  // save POST Contrat rattache
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renouvellerContratRattache: async (data: IPostSaveParams): Promise<any> => {
    return await api.post('common/contrat/rattache', {
      numeroPolice: data.numeroPolice,
      primeTTC: data.primeTTC,
      dateEffet: data.dateEffet,
      duration: data.duration,
      operationType: data.operationType,
      simulationId: data.simulationId,
      utilisateur: data.utilisateur,
    });
  },

  renouvellerAuto: async (data: FormData): Promise<ApiResponse> => {
    return await postFormData('auto/renouvellement', data);
  },

  getMontantAuto: async (
    data: IPostTarifAutoParams,
  ): Promise<ApiResponse<IPostTarifAutoResponse>> => {
    return await api.get(
      `auto/pricing?policyNumber=${data.policyNumber}&startDate=${data.startDate}`,
    );
  },

  // delete Contrat rattache
  deleteContrat: async (
    data: IDeleteContratRattache,
  ): Promise<IPostSaveResponse> => {
    return await api.remove(`common/contrat/rattache?id=${data.id}`);
  },
});
